(() => {
  const root = document.getElementById('pfb-bfcm-promo');
  if (!root || window.PowerfulFormBfcmPromo?.initialized) return;

  // Boundaries in GMT+7, same as the app's campaign (Oct 15 00:00 → Nov 21 00:00 → Dec 1 00:00 GMT+7)
  const gmt7 = (year, month, day) => Date.UTC(year, month, day, 0, 0, 0) - 7 * 60 * 60 * 1000;

  const phases = [
    {
      id: 'early-bird',
      name: 'Early Bird',
      start: gmt7(2026, 9, 15),
      end: gmt7(2026, 10, 21),
      percent: '50%',
      trigger: 'First 3 months',
      title: 'Get 50% off your first 3 months',
      description: 'Choose any paid monthly plan and save 50% for the first 3 months.',
      annual: 'Prefer yearly billing? Get 25% off your first year.',
      code: 'BFCM2026'
    },
    {
      id: 'bfcm',
      name: 'Black Friday',
      start: gmt7(2026, 10, 21),
      end: gmt7(2026, 11, 1),
      percent: '25%',
      trigger: 'First 3 months',
      title: 'Get 25% off your first 3 months',
      description: 'Choose any paid monthly plan and save 25% for the first 3 months.',
      annual: 'Prefer yearly billing? Get 20% off your first year.',
      code: 'BFCM2026'
    }
  ];

  const resolvePhase = (timestamp) => phases.find((phase) => timestamp >= phase.start && timestamp < phase.end) || null;
  window.PowerfulFormBfcmPromo = Object.freeze({ initialized: true, resolvePhase });

  const previewPhase = window.Shopify?.designMode
    ? new URLSearchParams(window.location.search).get('pfb_bfcm_preview')
    : null;
  const phase = phases.find((item) => item.id === previewPhase) || resolvePhase(Date.now());
  if (!phase) return;

  root.dataset.phase = phase.id;
  root.querySelector('[data-pfb-promo-badge]').textContent = phase.percent + ' OFF';
  root.querySelector('[data-pfb-promo-trigger-text]').textContent = phase.trigger;
  root.querySelector('[data-pfb-promo-duration]').textContent = phase.trigger;
  root.querySelector('[data-pfb-promo-phase]').textContent = phase.name;
  root.querySelector('[data-pfb-promo-percent]').textContent = phase.percent;
  root.querySelector('[data-pfb-promo-title]').textContent = phase.title;
  root.querySelector('[data-pfb-promo-description]').textContent = phase.description;
  root.querySelector('[data-pfb-promo-annual]').textContent = phase.annual;
  root.querySelector('[data-pfb-promo-code]').textContent = phase.code;

  const locale = document.documentElement.lang || navigator.language || 'en';
  const localEnd = new Intl.DateTimeFormat(locale, {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short'
  }).format(new Date(phase.end - 60000));
  root.querySelector('[data-pfb-promo-end]').textContent = localEnd;

  const trigger = root.querySelector('.pfb-promo__trigger');
  const overlay = root.querySelector('[data-pfb-promo-overlay]');
  const dialog = root.querySelector('.pfb-promo__dialog');
  const closeButton = root.querySelector('.pfb-promo__close');
  const copyButton = root.querySelector('.pfb-promo__copy');
  let previouslyFocused = null;

  // Escape is only listened for while the dialog is open, so no keydown handler stays bound on every page
  const onKeydown = (event) => { if (event.key === 'Escape') closeDialog(); };
  const openDialog = () => {
    previouslyFocused = document.activeElement;
    overlay.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    document.addEventListener('keydown', onKeydown);
    dialog.focus();
  };
  const closeDialog = () => {
    overlay.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    document.removeEventListener('keydown', onKeydown);
    previouslyFocused?.focus();
  };

  copyButton.addEventListener('click', async () => {
    const originalLabel = copyButton.textContent;
    try {
      await navigator.clipboard.writeText(phase.code);
    } catch (error) {
      const input = document.createElement('textarea');
      input.value = phase.code;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    }
    copyButton.textContent = 'Copied!';
    window.setTimeout(() => { copyButton.textContent = originalLabel; }, 1800);
  });

  trigger.addEventListener('click', openDialog);
  closeButton.addEventListener('click', closeDialog);
  overlay.addEventListener('click', (event) => { if (event.target === overlay) closeDialog(); });

  root.hidden = false;
})();